const DEFAULT_EVENT_SETTINGS = {
  formats: [
    {
      id: "padrao",
      label: "Quiz Padrão",
      typeLabel: "Tipo de Quiz",
      themeLabel: "Tema especial da rodada",
      themeMode: "optional",
      supportsSpecialTitle: false,
      specialTitleLabel: "Título Especial",
      supportsSpecialRounds: false,
      specialRoundsLabel: "Rodadas Especiais",
      titleTemplateWithTheme: "{type} + {theme}",
      titleTemplateWithoutTheme: "{type} + Rodada Temática",
      descriptionTemplateWithTheme: "3 Rodadas de {type} ({type_description}) + Rodada temática de {theme}.",
      descriptionTemplateWithoutTheme: "3 Rodadas de {type} ({type_description}) + Rodada temática a definir.",
      types: [
        { id: "variedades", label: "Variedades", description: "História, Geografia, Ciências, Mundo Animal, Música, Cinema, etc" },
        { id: "cultura_geek", label: "Cultura Geek", description: "Séries, Desenhos Animados, Quadrinhos, Games e Cinema" },
        { id: "cultura_pop", label: "Cultura Pop", description: "Cinema e TV, Conhecimentos Gerais e Música" },
      ],
    },
    {
      id: "fandom",
      label: "Quiz Fandom",
      typeLabel: "Tipo de Quiz",
      themeLabel: "Tema especial da rodada",
      themeMode: "required",
      supportsSpecialTitle: false,
      specialTitleLabel: "Título Especial",
      supportsSpecialRounds: false,
      specialRoundsLabel: "Rodadas Especiais",
      titleTemplateWithTheme: "Quiz Fandom: 4 rodadas de {theme}",
      titleTemplateWithoutTheme: "Quiz Fandom: 4 rodadas de [Tema]",
      descriptionTemplateWithTheme: "4 rodadas exclusivas sobre {theme}.",
      descriptionTemplateWithoutTheme: "4 rodadas exclusivas sobre [Tema].",
      types: [
        { id: "fandom", label: "Fandom", description: "Rodadas totalmente focadas em um Ãºnico universo." },
      ],
    },
    {
      id: "especial",
      label: "Quiz Especial",
      typeLabel: "Tipo de Quiz",
      themeLabel: "Tema especial da rodada",
      themeMode: "hidden",
      supportsSpecialTitle: true,
      specialTitleLabel: "Título Especial",
      supportsSpecialRounds: true,
      specialRoundsLabel: "Rodadas Especiais",
      titleTemplateWithTheme: "Quiz Especial: {special_title}",
      titleTemplateWithoutTheme: "Quiz Especial: {special_title}",
      descriptionTemplateWithTheme: "Quiz Especial com 4 rodadas temáticas: {special_rounds_joined}.",
      descriptionTemplateWithoutTheme: "Quiz Especial com 4 rodadas temáticas.",
      types: [
        { id: "especial", label: "Especial", description: "Evento com rodadas especiais curadas manualmente." },
      ],
    },
  ],
};

const cleanText = (value) => String(value || "").trim();

const slugifyValue = (value) =>
  cleanText(value)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");

export const createEventConfigId = (value, fallback = "item") => slugifyValue(value) || fallback;

export const normalizeEventSettings = (value) => {
  const source = value && Array.isArray(value.formats) && value.formats.length > 0
    ? value
    : DEFAULT_EVENT_SETTINGS;

  return {
    formats: source.formats.map((format, formatIndex) => ({
      id: cleanText(format.id) || `format_${formatIndex + 1}`,
      label: cleanText(format.label) || `Formato ${formatIndex + 1}`,
      typeLabel: cleanText(format.typeLabel) || "Tipo",
      themeLabel: cleanText(format.themeLabel) || "Tema especial da rodada",
      themeMode: ["hidden", "optional", "required"].includes(format.themeMode) ? format.themeMode : "optional",
      supportsSpecialTitle: format.supportsSpecialTitle === true,
      specialTitleLabel: cleanText(format.specialTitleLabel) || "Título Especial",
      supportsSpecialRounds: format.supportsSpecialRounds === true,
      specialRoundsLabel: cleanText(format.specialRoundsLabel) || "Rodadas Especiais",
      titleTemplateWithTheme: cleanText(format.titleTemplateWithTheme),
      titleTemplateWithoutTheme: cleanText(format.titleTemplateWithoutTheme),
      descriptionTemplateWithTheme: cleanText(format.descriptionTemplateWithTheme),
      descriptionTemplateWithoutTheme: cleanText(format.descriptionTemplateWithoutTheme),
      types: Array.isArray(format.types) && format.types.length > 0
        ? format.types.map((type, typeIndex) => ({
            id: cleanText(type.id) || `type_${typeIndex + 1}`,
            label: cleanText(type.label) || `Tipo ${typeIndex + 1}`,
            description: cleanText(type.description),
          }))
        : [{ id: "default", label: "PadrÃ£o", description: "" }],
    })),
  };
};

export const getEventFormatConfig = (eventSettings, formatId) => {
  const normalized = normalizeEventSettings(eventSettings);
  return normalized.formats.find((format) => format.id === formatId) || normalized.formats[0];
};

export const getEventTypeConfig = (formatConfig, typeLabel) => {
  if (!formatConfig) return null;
  return (
    formatConfig.types.find((type) => type.label === typeLabel || type.id === typeLabel) ||
    formatConfig.types[0] ||
    null
  );
};

const fillTemplate = (template, values) =>
  String(template || "").replace(/\{([a-z_]+)\}/gi, (_, key) => values[key] ?? "");

export const generateEventTitleAndDescription = (form, eventSettings) => {
  const formatConfig = getEventFormatConfig(eventSettings, form.event_format);
  const typeConfig = getEventTypeConfig(formatConfig, form.quiz_type);
  const theme = cleanText(form.thematic_round_theme);
  const specialTitle = cleanText(form.special_title);
  const specialRoundsJoined = (form.special_rounds || []).map(cleanText).filter(Boolean).join(", ");

  const values = {
    format: formatConfig?.label || "",
    type: typeConfig?.label || cleanText(form.quiz_type),
    type_description: typeConfig?.description || "",
    theme,
    special_title: specialTitle || "[TÃ­tulo]",
    special_rounds_joined: specialRoundsJoined,
  };

  const useThemeTemplate = formatConfig?.themeMode !== "hidden" && theme;
  const titleTemplate = useThemeTemplate
    ? formatConfig?.titleTemplateWithTheme
    : formatConfig?.titleTemplateWithoutTheme || formatConfig?.titleTemplateWithTheme;
  const descriptionTemplate = useThemeTemplate
    ? formatConfig?.descriptionTemplateWithTheme
    : formatConfig?.descriptionTemplateWithoutTheme || formatConfig?.descriptionTemplateWithTheme;

  return {
    title: fillTemplate(titleTemplate, values).trim(),
    description: fillTemplate(descriptionTemplate, values).trim(),
  };
};

export const getDefaultEventSettings = () => normalizeEventSettings(DEFAULT_EVENT_SETTINGS);

